import script from "./StepProgress.vue?vue&type=script&setup=true&lang=js"
export * from "./StepProgress.vue?vue&type=script&setup=true&lang=js"

import "./StepProgress.vue?vue&type=style&index=0&id=79d5360f&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79d5360f"]])

export default __exports__